export enum ReportsType {
  BY_ROUNDS = '1',
  BY_GAME = '2',
  BY_CATEGORY = '3',
  BY_PROVIDER = '4',
  BY_PLAYER_ID = '5',
  BY_BRAND = '6',
}
